import script from "./MmCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./MmCategories.vue?vue&type=script&setup=true&lang=js"

import "./MmCategories.vue?vue&type=style&index=0&id=7801ad20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7801ad20"]])

export default __exports__